export const nameForAnalytics = 'data-navigation-label';

declare module 'rc-menu/lib/interface' {
    interface MenuItemType {
        [nameForAnalytics]?: string;
    }

    interface SubMenuType {
        [nameForAnalytics]?: string;
    }

    interface MenuItemGroupType {
        [nameForAnalytics]?: string;
    }

    interface MenuDividerType {
        [nameForAnalytics]?: string;
    }
}
